import cart from './iamota-shopify-ajax/cart';
import product from './iamota-shopify-ajax/product';
import productRecommendations from './iamota-shopify-ajax/productRecommendations';
import sectionRendering from './iamota-shopify-ajax/sectionRendering';
export { cart, product, productRecommendations, sectionRendering };